import { useNow } from '@/common/hooks/useNow';
import { DispenserEvent } from '@/features/dispensers/services/schemas.ts';
import { Trans } from '@lingui/react/macro';
import { differenceInHours } from 'date-fns/differenceInHours';
import { differenceInDays } from 'date-fns/differenceInDays';
import { plural } from '@lingui/core/macro';

const MAX_DAYS_TO_DISPLAY = 90;

export interface HowLongAgoProps {
  event: DispenserEvent;
}

export const HowLongAgo = ({ event }: HowLongAgoProps) => {
  const now = useNow();

  const isLessThanDayAgo = differenceInHours(now, event.eventAt) < 24;
  const daysAgo = differenceInDays(now, event.eventAt);
  const isMoreThanMaxDaysAgo = daysAgo > MAX_DAYS_TO_DISPLAY;

  if (isLessThanDayAgo) {
    return <Trans>&lt; 1 day</Trans>;
  }
  if (isMoreThanMaxDaysAgo) {
    return <Trans>&gt; 3 months</Trans>;
  }

  return plural(daysAgo, {
    other: '#d ago',
  });
};
